import React from 'react';
import { iconStyling } from './icons.ve.css';

export const FreelancerShopifyIcon: React.FC = () => (
    <svg className={iconStyling} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.8837 4.90698V2.67442C14.8837 2.36617 14.6338 2.11628 14.3256 2.11628H1.67442C1.36617 2.11628 1.11628 2.36617 1.11628 2.67442V13.093C1.11628 13.4013 1.36617 13.6512 1.67442 13.6512H4.27907C4.58732 13.6512 4.83721 13.9011 4.83721 14.2093C4.83721 14.5176 4.58732 14.7674 4.27907 14.7674H1.67442C0.749663 14.7674 1.49827e-08 14.0178 0 13.093V2.67442C1.67809e-07 1.74966 0.749663 1 1.67442 1H14.3256C15.2503 1 16 1.74966 16 2.67442V4.90698C16 5.21523 15.7501 5.46512 15.4419 5.46512C15.1336 5.46512 14.8837 5.21523 14.8837 4.90698Z"
            fill="#222325"
        />
        <path
            d="M12.4649 4.16284C12.7732 4.16284 13.0231 4.41273 13.0231 4.72098C13.0231 5.02923 12.7732 5.27912 12.4649 5.27912L3.5347 5.27912C3.22645 5.27912 2.97656 5.02923 2.97656 4.72098C2.97656 4.41273 3.22645 4.16284 3.5347 4.16284L12.4649 4.16284Z"
            fill="#222325"
        />
        <path
            d="M6.51145 7.51172L6.56886 7.51463C6.85014 7.54337 7.06959 7.78099 7.06959 8.06986C7.06959 8.35873 6.85014 8.59635 6.56886 8.62509L6.51145 8.628H3.5347C3.22645 8.628 2.97656 8.37811 2.97656 8.06986C2.97656 7.76161 3.22645 7.51172 3.5347 7.51172L6.51145 7.51172Z"
            fill="#222325"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 11.9615C13.0948 11.9615 13.5769 11.4794 13.5769 10.8846C13.5769 10.2898 13.0948 9.80769 12.5 9.80769C11.9052 9.80769 11.4231 10.2898 11.4231 10.8846C11.4231 11.4794 11.9052 11.9615 12.5 11.9615ZM12.5 12.7692C13.5408 12.7692 14.3846 11.9255 14.3846 10.8846C14.3846 9.84377 13.5408 9 12.5 9C11.4592 9 10.6154 9.84377 10.6154 10.8846C10.6154 11.9255 11.4592 12.7692 12.5 12.7692Z"
            fill="#222325"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.82994 15.1923C9.91874 14.9412 10.3573 14.1154 12.5001 14.1154C14.6427 14.1154 15.0813 14.9412 15.1701 15.1923H9.82994ZM12.5001 13.3077C9.56388 13.3077 9 14.7847 9 15.2586C9 15.7317 9.38254 16 9.73984 16H15.2602C15.6173 16 16 15.7319 16 15.2586C16 14.7847 15.4361 13.3077 12.5001 13.3077Z"
            fill="#222325"
        />
    </svg>
);

FreelancerShopifyIcon.displayName = 'FreelancerShopifyIcon';
